/* eslint-disable no-useless-escape */
import React, { useRef } from "react";
import PropTypes from "prop-types";
import {
  FieldSet,
  FormGroupInput,
  CustomDatePicker,
} from "components/formElements";
import {
  getNameErrorMessage,
  getPhoneNumberErrorMessage,
  getAlternatePhoneNumberErrorMessage,
  getEmailErrorMessage,
} from "util/validations";
import { getDateNYearsAgo } from "../../../util/library";
import {
  getExistingCandidateByEmail,
  getExistingCandidateByPhone,
} from "service/formService";

const PersonalInfo = ({
  fullName,
  emailaddress,
  phoneNumber,
  alternatePhoneNumber,
  linkedInProfile,
  dateOfBirth,
  handleChange,
  handleDateChange,
  dateOfBirthError,
  setSubmitErrorMessage,
}) => {
  const inputRef = useRef(null);
  const emailRef = useRef(null);

  const handleBlurEmail = async () => {
    const email = emailaddress.trim();
    if (email !== "") {
      try {
        const response = await getExistingCandidateByEmail(email);
        setSubmitErrorMessage("");
      } catch (err) {
        setSubmitErrorMessage(err.response.data[0]);
        console.error(err.response.data[0]);
      }
    }
  };

  const handleBlurPhone = async () => {
    const phone = phoneNumber.trim();
    if (phone !== "") {
      try {
        const response = await getExistingCandidateByPhone(phone);
        setSubmitErrorMessage("");
      } catch (err) {
        setSubmitErrorMessage(err.response.data[0]);
        console.error(err.response.data[0]);
      }
    }
  };

  return (
    <FieldSet legendText="Personal Information">
      <FormGroupInput
        id="fullName"
        name="fullName"
        type="text"
        label="Full Name"
        value={fullName}
        // placeholder="Full Name"
        onChange={handleChange}
        errorMessage={getNameErrorMessage(fullName, "Name", true)}
        required
        pattern={"[A-Za-z]([-']?[A-Za-z]+)*( [A-Za-z]([-']?[A-Za-z]+)*){0,}"}
      />
      <FormGroupInput
        id="emailaddress"
        name="emailaddress"
        type="text"
        label="Email"
        value={emailaddress}
        //placeholder="E-Mail Id"
        onBlur={handleBlurEmail}
        onChange={handleChange}
        inputRef={emailRef}
        errorMessage={getEmailErrorMessage(emailRef, emailaddress)}
        required
      />
      <CustomDatePicker
        id="dob"
        name="dob"
        type="date"
        label="Date Of Birth"
        selected={dateOfBirth}
        onChange={handleDateChange}
        errorMessage={"Date of Birth can't be blank"}
        openToDateYearRange={getDateNYearsAgo(18)}
        minDateYearRange={getDateNYearsAgo(50)}
        maxDateYearRange={getDateNYearsAgo(18)}
        dateError={dateOfBirthError}
        required
      />
      <FormGroupInput
        id="phoneNumber"
        name="phoneNumber"
        type="text"
        label="Phone Number"
        //placeholder="Phone Number"
        value={phoneNumber}
        onBlur={handleBlurPhone}
        onChange={handleChange}
        inputGroupText="+91"
        errorMessage={getPhoneNumberErrorMessage(phoneNumber)}
        required
        pattern={"[0-9]{10}"}
      />
      <FormGroupInput
        id="alternatePhoneNumber"
        name="alternatePhoneNumber"
        type="text"
        label="Alternate Phone Number"
        //placeholder="Alternate Phone Number"
        value={alternatePhoneNumber}
        onChange={handleChange}
        inputGroupText="+91"
        inputRef={inputRef}
        errorMessage={getAlternatePhoneNumberErrorMessage(
          inputRef,
          phoneNumber,
          alternatePhoneNumber
        )}
        pattern={"[0-9]{10,12}"}
      />
      <FormGroupInput
        id="linkedInProfile"
        name="linkedInProfile"
        type="text"
        label="LinkedIn Profile Link"
        //placeholder="e.g. https://www.linkedin.com/in/amit-b5673336/"
        value={linkedInProfile}
        errorMessage={"Invalid LinkedIn profile link"}
        onChange={handleChange}
        // pattern="(https?:\/\/)?(www\.)?linkedin\.com\/in\/\S+"
      />
      <FormGroupInput style={{ display: "none" }} />
    </FieldSet>
  );
};

PersonalInfo.propTypes = {
  handleChange: PropTypes.func.isRequired,
  handleDateChange: PropTypes.func.isRequired,
  fullName: PropTypes.string.isRequired,
  emailaddress: PropTypes.string.isRequired,
  phoneNumber: PropTypes.string.isRequired,
  alternatePhoneNumber: PropTypes.string.isRequired,
  linkedInProfile: PropTypes.string.isRequired,
  dateOfBirthError: PropTypes.bool.isRequired,
};

export { PersonalInfo };
